import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { colors } from "../../values/colors";

const CustomTabs = ({ value, setValue, arr }) => {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box
      sx={{
        display: "flex",
        mt: 1,
        paddingX: "3rem",
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        TabIndicatorProps={{ style: { display: "none" } }} // remove default underline
        sx={{
          backgroundColor: "#fff",
          borderRadius: "50px",
          boxShadow: "0 0 5px rgba(0,0,0,0.1)",
          padding: "4px",
          border: `0.5px solid #CACACA`,
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 500,
            fontSize: "20px",
            borderRadius: "50px",
            minHeight: "40px",
            minWidth: "150px",
          },
        }}
      >
        {arr.map((label, index) => (
          <Tab
            key={label}
            label={label}
            disableRipple
            sx={{
              textTransform: "none",
              fontFamily: "Urbanist,sans-serif",
              fontWeight: 500,
              fontSize: "20px",
              borderRadius: "50px",
              minHeight: "40px",
              minWidth: "150px",
              color: value === index ? "#fff !important" : "#333 !important", // 👈 override MUI color
              background:
                value === index ? colors.linearGradent : "transparent",
              transition: "all 0.3s ease",
              "&.Mui-selected": {
                color: "#fff !important", // 👈 force white when selected
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default CustomTabs;
